import { FC } from "react";
import { useRouter } from "next/router";

import { ProductWithSpecificationsAndDetails } from "@interfaces/product";

type Props = Pick<ProductWithSpecificationsAndDetails, "details">;

const HighlightInformation: FC<Props> = ({ details }) => {
  const { locale } = useRouter();

  return details && details.length > 0 ? (
    <div className="text-black flex flex-col md:flex-row justify-evenly content-center py-14">
      {details.map(({ heading, text, headingEn, textEn }) => (
        <div
          key={heading}
          className="flex flex-col flex-1 items-center px-3 space-y-3 text-center"
        >
          <h3 className="text-xl font-bold">
            {locale === "en" ? headingEn : heading}
          </h3>
          <span>{locale === "en" ? textEn : text}</span>
        </div>
      ))}
    </div>
  ) : null;
};

export default HighlightInformation;
